<template>
    <div class="d-flex align-items-center justify-content-center px-1 bg-warning">
        <p class="py-1 mb-0 me-1">
            <strong v-html="text" />
        </p>

        <OverlayDialog
            :id="'discount-info-overlay'"
            :modal-button-label="'Retour'"
            :action-label="'test'"
            :tms-category="overlay.tms.category"
            :tms-action="overlay.tms.action"
            :tms-label="overlay.tms.label"
            :modal-title="overlay.title"
            :html-content="overlay.content"
            :is-action-button="false"
            :is-icon-button="true"
            :icon-name="'icon-info-alt'"
            :aria-label="'En savoir plus sur la remise'"
        />
    </div>
</template>

<script>
import OverlayDialog from "../../../common/components/ob1/OverlayDialog.vue";

export default {
    name: "DiscountInfoBanner",
    components: {OverlayDialog},
    props: {
        text: {
            type: String,
            required: true
        },
        overlay: {
            type: Object,
            required: true
        }
    }
}
</script>

